// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"99":"f35dc8cc","401":"7cbba300","696":"be1fc907","818":"826baf81","915":"c3e3c640"}[chunkId] + ".css";
};